// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manufacturer } from './manufacturer';
import { PoCancelRequestQueue } from './po-cancel-request-queue';
import { PoDetail } from './po-detail';
import { PoNote } from './po-note';
import { PoStatus } from './po-status';
import { Warehouse } from './warehouse';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoHeader extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // conceptual Note interface
  getNotes() {
    return this.poNotes;
  }

  isProcessed() {
    return this.poStatusId > "1000.00";
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(255) */
  instructions?: string;
  /** Boolean */
  isLocked!: boolean;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** DateTime */
  origExpectedReceiveDate?: Date;
  /** DateTime */
  poDate?: Date;
  /** String(7) FK poStatus */
  poStatusId!: string;
  /** Binary */
  rowVersion!: any;
  /** Int32 FK shippingWarehouse */
  shippingWarehouseId!: number;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** Inv FK poHeaderId */
  poCancelRequestQueues!: PoCancelRequestQueue[];
  /** Inv FK poHeaderId */
  poDetails!: PoDetail[];
  /** Inv FK poHeaderId */
  poNotes!: PoNote[];
  /** FK poStatusId */
  poStatus!: PoStatus;
  /** FK shippingWarehouseId */
  shippingWarehouse!: Warehouse;
}

